module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-bar"
  }, [_c('el-row', [_c('el-col', {
    staticClass: "global-action",
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.name === 'jars' || _vm.$route.name === 'servers'),
      expression: "$route.name === 'jars' || $route.name === 'servers'"
    }],
    attrs: {
      "icon": "plus",
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.bus.$emit(_vm.event.ADD_CLICK)
      }
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.bus.$emit(_vm.event.REFRESH_CLICK)
      }
    }
  }, [_vm._v("Refresh")]), _vm._v(" "), _c('el-switch', {
    on: {
      "change": _vm.toggleAutoRefresh
    },
    model: {
      value: (_vm.autoRefresh),
      callback: function($$v) {
        _vm.autoRefresh = $$v
      },
      expression: "autoRefresh"
    }
  }), _vm._v(" "), _vm._v("\n       \n    ")], 1), _vm._v(" "), _c('el-col', {
    staticClass: "user-action",
    attrs: {
      "span": 12
    }
  }, [_vm._v("\n      Server: " + _vm._s(_vm.$store.state.address) + "\n      "), _c('el-button', {
    attrs: {
      "icon": "edit",
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/login')
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-dfac12e2"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/header/Right.vue
// module id = 174
// module chunks = 1